import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Home from "./pages/Home";
import Products from "./pages/Products";
import InvestmentPlans from "./pages/InvestmentPlans";
import Ambassador from "./pages/Ambassador";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import AccountTypes from "./pages/AccountTypes";

// Мягкая анимация появления/исчезновения
const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: { duration: 0.4, ease: "easeIn" },
  },
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{
          width: "100%",
          minHeight: "100vh",
          backgroundColor: "#ffffff", // ← белый фон
          transition: "background-color 0.8s ease", // плавная смена фона
        }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/investment" element={<InvestmentPlans />} />
          <Route path="/accounttypes" element={<AccountTypes />} />
          <Route path="/ambassador" element={<Ambassador />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
